import React, { useEffect } from "react";
import {Redirect, Route, Switch } from "react-router-dom";
import Landing from "./sections/landing";
import Approved from "../global-elements/approved/approved2";
import Declined from "../global-elements/declined";
import { useStoreState, useStoreActions } from "easy-peasy";
import DeclinedTemporal from "../global-elements/declinedTemporal";
import Error404 from "../../systempages/error404/Error404";
import GrandBankPage from "../global-elements/grandbank/grandbankPage";
import LinkBankAccount from '../linkBankAccount/linkBankAccount';
import { InactiveDetection } from "../../../services/inactiveDetection";
import ApprovedGrandBank from "../global-elements/approved/approved_grandbank";
import PDFTerms from "../global-elements/PDFTerms";
import { FLOW, PRODUCT } from "../../../models/websiteTypesConstants";

function Layout() {

  const resultStep        = useStoreState(state => state.displayResult);
  const MainPath          = useStoreState(state => state.siteSettingsModel.MainPath);
  const PathBasedSite     = useStoreState(state => state.siteSettingsModel.PathBasedSite);
  const setting           = useStoreState(state => state.siteSettingsModel);
  const setProductPath    = useStoreActions(actions => actions.siteSettingsModel.setMainPath);
  
  InactiveDetection.setInactiveTitle(null);
  useEffect(() => {
      document.querySelector("title").textContent = `${setting.brandSettings.ProductName || ""} - Mastercard`;
      InactiveDetection.setTitle(`${setting.brandSettings.ProductName || ""} - Mastercard`);
      if(MainPath === "/" && PathBasedSite === true){
          setProductPath((window.location.pathname.split("/")[1] === '') ? "/" : "/" + window.location.pathname.split('/')[1] + "/");
      }
  },[setting]);

  return (
    <>
      <Route path="/getTerms/:productCode" component={() => <PDFTerms />} exact />
      {setting.mainSettings.Flow === FLOW.CFC && PathBasedSite === false && (
        <Switch>
          {/* Landing page No form */}
          <Route path="/" component={() => <Landing />} exact />
          {/* Landing page No form */}
          <Route path="/approved" component={() => (resultStep) ?  (setting.brandSettings.ProductName === PRODUCT.Grand.bank ? <ApprovedGrandBank /> : <Approved />) : <Redirect to={"/"+window.location.search} />} exact />
          {/* Terms page No form */}
          <Route path="/decision" component={() => (resultStep) ? <Declined /> : <Redirect to={"/"+window.location.search} />} exact/>
          <Route path="/grandbank" component={() => (resultStep) ? <GrandBankPage /> : <Redirect to={"/"+window.location.search} />} exact/>
          <Route path="/pendinfo" component={() => (resultStep) ? <DeclinedTemporal /> : <Redirect to={"/"+window.location.search} />} exact />
          <Route path="/link-account" component={() => (resultStep) ? <LinkBankAccount /> : <Redirect to={"/" + window.location.search} />} exact />

          <Route  component={() => <Error404 />}  />
        </Switch>
      )}

      {setting.mainSettings.Flow === FLOW.CFC && PathBasedSite === true && (
        <Switch>
          <Route path="/" component={() => (MainPath !== "/") ? <Redirect to={"/" + MainPath + window.location.search} /> : <Error404 />} exact />
            <Route path="/:MainPath" component={() => (MainPath !== "/" && "/" + window.location.pathname.split('/')[1] + "/" === MainPath) ? <Landing /> : <Error404 />} exact />
            <Route path="/:MainPath/approved" component={() => (resultStep) ? (setting.brandSettings.ProductName === PRODUCT.Grand.bank ? <ApprovedGrandBank /> : <Approved />) : <Redirect to={"/" + window.location.pathname.split('/')[1] + window.location.search} />} exact />
            {/* Terms page No form */}
            <Route path="/:MainPath/decision" component={() => (resultStep) ? <Declined /> : <Redirect to={"/" + window.location.pathname.split('/')[1] + window.location.search} />} exact/>
            <Route path="/:MainPath/grandbank" component={() => (resultStep) ? <GrandBankPage /> : <Redirect to={"/" + window.location.pathname.split('/')[1] + window.location.search} />} exact/>
            <Route path="/:MainPath/pendinfo" component={() => (resultStep) ? <DeclinedTemporal /> : <Redirect to={"/" + window.location.pathname.split('/')[1] + window.location.search} />} exact />
            <Route path="/:MainPath/link-account" component={() => (resultStep) ? <LinkBankAccount /> : <Redirect to={"/" + window.location.search} />} exact />
            <Route  component={() => <Error404 />}  />
        </Switch>
      )}
    </>
    
  );
}

export default Layout;
